import {useTranslation} from 'react-i18next';
import personSilhouette from '@/assets/person_silhouette.svg';

type FaceFrameProps = {
  offsetTop: number;
}

export function FaceFrame({ offsetTop }: FaceFrameProps) {
  const { t } = useTranslation();

  return (
    <div className="absolute z-10 w-full" style={{ top: offsetTop }}>
      <img
        alt=""
        src={personSilhouette}
        className="w-full"
      />
      <p className="absolute top-3 w-full px-5 text-center text-lg text-white font-bold">
        {t('answers.face_frame_instruction')}
      </p>
    </div>
  )
}
